var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.99718 9.77756C8.45178 9.77756 10.4416 7.78772 10.4416 5.33312C10.4416 2.87852 8.45178 0.888672 5.99718 0.888672C3.54258 0.888672 1.55273 2.87852 1.55273 5.33312C1.55273 7.78772 3.54258 9.77756 5.99718 9.77756Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99682 6.67097C5.91237 6.67097 5.82793 6.63986 5.76126 6.57319L4.19237 5.0043C4.06348 4.87541 4.06348 4.66208 4.19237 4.53319C4.32126 4.4043 4.53459 4.4043 4.66348 4.53319L5.99682 5.86652L7.33015 4.53319C7.45904 4.4043 7.67237 4.4043 7.80126 4.53319C7.93015 4.66208 7.93015 4.87541 7.80126 5.0043L6.23237 6.57319C6.1657 6.63986 6.08126 6.67097 5.99682 6.67097Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrowDown);
export default __webpack_public_path__ + "static/media/RoundArrowDown.77874434694807ddb4fda306ecfd7dd3.svg";
export { ForwardRef as ReactComponent };